import { useMergeLink } from "@mergeapi/react-merge-link";
import React from "react";
import { useState } from "react";
import { getTenantConfigForMergeLink } from "../../../linked-accounts/AddTestLinkedAccountButton";
import { Button } from "@merge-api/merge-javascript-shared";
import useAppContext from "../../../../context/useAppContext";

interface Props {
  /**
   * Called when a new account is linked via the linking flow.
   */
  linkToken: string;
  onNewLinkedAccount: (wasSuccess: boolean) => void;
}

const CustomAddTestLinkedAccountButton = ({ linkToken, onNewLinkedAccount }: Props) => {
  const [wasSuccess, setWasSuccess] = useState(false);
  const { user } = useAppContext();

  const { open, isReady } = useMergeLink({
    linkToken: linkToken,
    onSuccess: () => setWasSuccess(true),
    onExit: () => onNewLinkedAccount(wasSuccess),
    ...getTenantConfigForMergeLink(),
    filePickerConfig: {
      onSubmit: () => {},
      allowMultiSelect: true,
    },
  });

  // Hide the button if merge link buttons are disabled for this user
  if (user.is_merge_link_button_disabled) {
    return null;
  }

  return (
    <Button
      disabled={!isReady}
      fullWidth
      onClick={() => {
        setWasSuccess(false);
        open();
      }}
    >
      Open Merge Link
    </Button>
  );
};

export default CustomAddTestLinkedAccountButton;
